import { type HistoricalBudgetMixResponse } from "../../budget-mix-card-container/card-container";

import { HistoricalMainTitleSection } from "./main-title-section";
import { TitleSectionContainer } from "./title-section-container";

export function HistoricalTitleSection({
  historicalData,
}: {
  historicalData: HistoricalBudgetMixResponse;
}) {
  return (
    <TitleSectionContainer>
      <HistoricalMainTitleSection historicalData={historicalData} />
    </TitleSectionContainer>
  );
}
